export const iconFontAwesomeEditingEllipsis = (
	<i className="fa-solid fa-ellipsis"></i>
);
